import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Form } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import TooltipTrigger from "../../tooltip-trigger";
import "./filter-tools-view.scss";
import { useId } from "react";

//<editor-fold desc="Props">
export interface FilterToolsVisibilityProps {
  show?: boolean;
  onShow: () => void;
  onHide: () => void;
}
export interface TableFilterInternal {
  key: string;
  handler: (active: boolean) => void;
  isActive: boolean|undefined;
  content: string|JSX.Element;
}
export interface FilterToolsProps extends FilterToolsVisibilityProps {
  filters: TableFilterInternal[];
}
//</editor-fold>

export default function FilterTools(props: FilterToolsProps) {
  //<editor-fold desc="Local variables">
  const { filters, show, onShow, onHide } = props;
  //</editor-fold>

  //<editor-fold desc="Hooks">
  const intl = useIntl();
  const idPrefix = useId();
  //</editor-fold>
  const onToggleHandler = (isOpen: boolean, event: any, metadata: any) => {
    if (show) {
      if (metadata.source !== "select") {
        onHide();
      }
    } else {
      onShow();
    }
  };
  const hasActive = !!filters.find((f) => f.isActive);
  return (
    <Dropdown
      className={"btn-group filter-tools"}
      show={show}
      onToggle={onToggleHandler}
    >
      <TooltipTrigger
        tipKey={"toolsToggleFilterTip"}
        tip={intl.formatMessage({
          defaultMessage: "Select filters to control displayed items.",
          description: "Tooltip for the select filters button",
        })}
      >
        <Dropdown.Toggle
          variant={"theme-to-primary"}
          data-test-table-filters-trigger
        >
          <span className="fa-layers fa-fw " style={{ left: "-0.1em" }}>
            <FontAwesomeIcon
              icon="circle"
              mask={"filter"}
              className={"opacity-50"}
              transform="shrink-0 right-8 down-5"
            />
            <FontAwesomeIcon
              icon={hasActive ? "check-circle" : "ban"}
              transform="shrink-4 right-8 down-5"
            />
          </span>
        </Dropdown.Toggle>
      </TooltipTrigger>

      <Dropdown.Menu
        data-test-table-filters
        popperConfig={{
          modifiers: [
            {
              name: "computeStyles",
              options: {
                gpuAcceleration: false, // true by default. Without this random conf, unnecessary scrollbars are added to parents
              },
            },
          ],
        }}
      >
        <Dropdown.Header className={"border-bottom"}>
          <FormattedMessage
            defaultMessage="Toggle filters"
            description={"Heading for filters selection dropdown"}
          />
        </Dropdown.Header>
        {filters &&
          filters.map((c, i) => {
            return (
              <Dropdown.Item
                data-test-table-filter={c.key}
                key={c.key}
                onClick={() => c.handler(!c.isActive)}
              >
                <Form.Check
                  id={idPrefix + c.key}
                  readOnly
                  custom
                  checked={c.isActive}
                  type={"checkbox"}
                  label={c.content}
                />
              </Dropdown.Item>
            );
          })}
      </Dropdown.Menu>
    </Dropdown>
  );
}
